import React from 'react';
import styled from '@emotion/styled';

import { parseHtml } from '../../helpers';

import { BulletPoint } from '../../../types/types';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const Ul = styled.ul({
  display: 'flex',
  flexWrap: 'wrap',

  [mqBreakpoints.tablet]: {
    gap: pxToRem(48),
  },

  [mqBreakpoints.desktop]: {
    justifyContent: 'space-around',
    flexWrap: 'nowrap',
  },
});

const Li = styled.li({
  width: '100%',

  '& h4': {
    paddingBottom: pxToRem(16),
  },

  '& p': {
    paddingBottom: pxToRem(32),
  },

  [mqBreakpoints.tablet]: {
    width: pxToRem(256),

    '& p': {
      paddingBottom: 0,
    },
  },
});

type Props = {
  points: BulletPoint[];
};

export const BenefitsTpPoints: React.FC<Props> = ({ points }) => {
  if (!(points && points.length)) {
    return null;
  }
  return (
    <Ul className='unstyled' data-testid='mp-product-benefits-points'>
      {points?.map((point, i) => (
        <Li key={i}>
          <h4>{point.title}</h4>
          {point.description && <p>{parseHtml(point.description)}</p>}
        </Li>
      ))}
    </Ul>
  );
};
